/*! Oruga v0.8.12 | MIT License | github.com/oruga-ui/oruga */
import { _ as _sfc_main } from "./Autocomplete.vue_vue_type_script_setup_true_lang-D7a3Rjfy.mjs";
import { b as registerComponent } from "./config-C1k5NuG7.mjs";
const index = {
  install(app) {
    registerComponent(app, _sfc_main);
  }
};
export {
  _sfc_main as OAutocomplete,
  index as default
};
//# sourceMappingURL=autocomplete.mjs.map
